import { ActiveFilters, FilterType } from '@wwt/entities/filters'

export const excludeEmptyFilters = (filters: ActiveFilters) => {
	return filters.filter(filterElement => {
		if (
			filterElement.type === FilterType.AND ||
			filterElement.type === FilterType.OR
		) {
			return filterElement.optionIDs.length !== 0
		}

		if (
			filterElement.type === FilterType.RANGE ||
			filterElement.type === FilterType.PRICE_RANGE
		) {
			return (
				filterElement.rangeLower !== filterElement.defaultMin ||
				filterElement.rangeUpper !== filterElement.defaultMax
			)
		}

		return false
	})
}
